/**
 * Get the list view type string corresponding to the enum
 * @param listViewType the list view type of the table view
 */
export default function getListViewTypeString(listViewType) {
    var listViewTypeString;
    switch (listViewType) {
        case 0 /* Conversation */:
            listViewTypeString = 'Conversation';
            break;
        case 1 /* Message */:
            listViewTypeString = 'Message';
            break;
        default:
            listViewTypeString = 'Unknown';
            break;
    }
    return listViewTypeString;
}
//# sourceMappingURL=getListViewTypeString.js.map